import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { LoginInput } from "@reina/shared";
import { Button, Field, Panel, PanelBody, PanelHead, useToast } from "../../components";
import { useLogin, useMe } from "../../api/auth";
import { errorMessage } from "../../lib/format";

/** Centered POC-style panel; the only public route. */
export function LoginPage() {
  const me = useMe();
  const login = useLogin();
  const toast = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from ?? "/";

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginInput>({
    resolver: zodResolver(LoginInput),
    defaultValues: { email: "", password: "" },
  });

  if (me.data) return <Navigate to="/" replace />;

  const onSubmit = handleSubmit((values) =>
    login.mutate(values, {
      onSuccess: () => navigate(from, { replace: true }),
      onError: (error) => toast.push({ message: errorMessage(error), tone: "danger" }),
    })
  );

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24 }}>
      <Panel style={{ width: "min(430px, 100%)" }}>
        <PanelHead title="Reina Group" sub="price comparison — sign in" />
        <PanelBody>
          <form className="stack" onSubmit={onSubmit} noValidate>
            <Field label="Email" error={errors.email?.message}>
              <input
                className="field"
                type="email"
                autoComplete="email"
                placeholder="you@reina.group"
                {...register("email")}
              />
            </Field>
            <Field label="Password" error={errors.password?.message}>
              <input
                className="field"
                type="password"
                autoComplete="current-password"
                {...register("password")}
              />
            </Field>
            <Button variant="primary" type="submit" disabled={login.isPending}>
              {login.isPending ? "Signing in…" : "Sign in"}
            </Button>
          </form>
        </PanelBody>
      </Panel>
    </div>
  );
}
